import axiosInstant from "../axiosInstant";



/* ------------------------------------------------------------------ */
/* Auctions                                                            */
/* ------------------------------------------------------------------ */

/** Success: res.data · Failure: undefined */
export async function auctionsList(page, live, exhibition, online) {
  try {
    const res = await axiosInstant.get(
      `auction?page=${page === null ? 1 : page}${
        live === null ? "" : `&category=${live}`
      }${exhibition === null ? "" : `&category=${exhibition}`}${
        online === null ? "" : `&category=${online}`
      }`
    );
    return res.data;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data · Failure: error.response.data */
export async function auctionsLive() {
  try {
    const res = await axiosInstant.get(`live/current`);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/** Success: res.data · Failure: error.response.data */
export async function nextAuction(liveData, data) {
  // URL is built outside try/catch on purpose: as before, a missing `liveData`/`data`
  // rejects with its own TypeError instead of being routed to the error handler.
  const url = `live/lot/next?auction_id=${liveData.auction_id}&setId=${liveData.setId}&lot_number=${
    data === undefined ? liveData.LotNo : data.nextCount
  }`;
  try {
    const res = await axiosInstant.get(url);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/** Success: res.data.msg · Failure: undefined. Default auction_status: "UPCOMING". */
export async function mainAuction(auction_status) {
  try {
    const res = await axiosInstant.get(
      `/auction?category=LIVE_AUCTION&page=1&auction_status=${
        auction_status === undefined ? "UPCOMING" : auction_status
      }`
    );
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data.msg · Failure: undefined. Default auction_status: "UPCOMING". */
export async function lafuerzaAuction(auction_status) {
  try {
    const res = await axiosInstant.get(
      `/auction?category=ONLINE_AUCTION&page=1&auction_status=${
        auction_status === undefined ? "UPCOMING" : auction_status
      }`
    );
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}


export async function auctionsFiltering(auctionType, auction_status) {
  try {
    const res = await axiosInstant.get(
      `/auction?category=${auctionType}&page=1&auction_status=${
        auction_status === undefined ? "UPCOMING" : auction_status
      }`
    );
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data.msg · Failure: error.response.data. Default auction_status: "". */
export async function international(auction_status) {
  try {
    const res = await axiosInstant.get(
      `/auction?category=EXHIBITION&page=1&auction_status=${
        auction_status === undefined ? "" : auction_status
      }`
    );
    return res.data.msg;
  } catch (error) {
    return error.response.data;
  }
}

/** Success: res.data.msg · Failure: undefined */
export async function getUpcommingAuction() {
  try {
    const res = await axiosInstant.get(`/auction?page=1`);
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data · Failure: null (logs the error). */
export async function getAuctionById(id) {
  try {
    const res = await axiosInstant.get(`auction/${id}`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch auction by ID:", error);
    return null;
  }
}


export async function acutionOngoing() {
  try {
    const res = await axiosInstant.get("auction/");
    const filtered = res.data.msg.filter(
      (x) => x.c_type === "LIVE_AUCTION" || x.c_type === "ONLINE_AUCTION"
    );
    const sorted = filtered.sort((a, b) => b.id - a.id);
    return sorted.slice(0, 2);
  } catch (error) {
    console.error(error);
    return [];
  }
}

/** Success: res.data.msg · Failure: undefined */
export async function actionByID(id) {
  try {
    const res = await axiosInstant.get(`auction/${id}`);
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}

/* ------------------------------------------------------------------ */
/* Exhibitions                                                         */
/* ------------------------------------------------------------------ */

/** Success: res.data.msg · Failure: undefined */
export async function exhibitionBannerByID(id) {
  try {
    const res = await axiosInstant.get(`private-sales/details?id=${id}&page=`);
    return res.data.msg;
  } catch (error) {
    return undefined;
  }
}


export async function getExhibition(data) {
  try {
    const res = await axiosInstant.get(`auction?page=1&category=EXHIBITION`);
    return res.data.msg.filter((x) => x.auction_status === "ONGOING");
  } catch (error) {
    return undefined;
  }
}

/* ------------------------------------------------------------------ */
/* Lots, filters and bidding                                           */
/* ------------------------------------------------------------------ */

/** Success: res.data.msg · Failure: error.response.data.msg */
export async function getFilter(id) {
  try {
    const res = await axiosInstant.get(`lot/set?auction_id=${id === undefined ? "" : id}`);
    return res.data.msg;
  } catch (error) {
    return error.response.data.msg;
  }
}

/** Success: res.data · Failure: undefined */
export async function filterArtist(id) {
  try {
    const res = await axiosInstant.get(`lot/filtering?auction_id=${id}&limit=10`);
    return res.data;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data · Failure: error.response.data */
export async function getPreview(data) {
  // URL built outside try/catch on purpose (same rejection behaviour as before if `data` is missing).
  const url = `lot/preview_amount?auction_id=${data.auction_id}&amount=${data.amount}&lot_number=${data.lotNumber}`;
  try {
    const res = await axiosInstant.get(url);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/** Success: res.data · Failure: error.response.data.msg */
export async function getPlaceAmount(auction_id, set_id, lotNumber) {
  try {
    const res = await axiosInstant.get(
      `lot/place_amount?auction_id=${auction_id === undefined ? "" : auction_id}&set_id=${
        set_id === undefined ? "" : set_id
      }&lot_number=${lotNumber === undefined ? "" : lotNumber}`
    );
    return res.data;
  } catch (error) {
    return error.response.data.msg;
  }
}

/** POST live/placeBid. Success: res.data · Failure: error.response.data */
export async function postBid(data) {
  try {
    const res = await axiosInstant.post(`live/placeBid`, data);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/* ------------------------------------------------------------------ */
/* Favorites                                                           */
/* ------------------------------------------------------------------ */

/** POST lot/addFavorites. Success: res.data · Failure: error.response.data */
export async function addfavorite(data) {
  try {
    const res = await axiosInstant.post(`lot/addFavorites`, data);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/** POST lot/removeFavorites. Success: res.data · Failure: error.response.data */
export async function removefavorite(data) {
  try {
    const res = await axiosInstant.post(`lot/removeFavorites`, data);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}

/* ------------------------------------------------------------------ */
/* Private sales                                                       */
/* ------------------------------------------------------------------ */

/** Success: res.data · Failure: undefined */
export async function privatefilterArtist(id) {
  try {
    const res = await axiosInstant.get(`private-sales/filtering?id=${id}&pgroup=PRIVATE_SALE`);
    return res.data;
  } catch (error) {
    return undefined;
  }
}


export async function privateGroupFilter(group) {
  try {
    const res = await axiosInstant.get(`private-sales/filtering?id=0&pgroup=PRIVATE_SALE`);
    return res.data.data;
  } catch (error) {
    return undefined;
  }
}

/** Success: res.data · Failure: undefined */
export async function categories() {
  try {
    const res = await axiosInstant.get(`private-sales/categories`);
    return res.data;
  } catch (error) {
    return undefined;
  }
}

/* ------------------------------------------------------------------ */
/* Contact                                                             */
/* ------------------------------------------------------------------ */

/** POST request/contactus. Success: res.data · Failure: error.response.data */
export async function contactus(data) {
  try {
    const res = await axiosInstant.post(`request/contactus`, data);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
}